"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["id"];
const _hoisted_2 = { class: "flex flex-col items-center gap-2 lg:flex-row" };
const _hoisted_3 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "block w-10 text-center" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-search text-lg text-gray-dark" })
], -1);
const _hoisted_4 = ["placeholder"];
const _hoisted_5 = {
    id: "sku-tag-search-input-tags-container",
    class: "flex flex-row items-center gap-2 flex-1 w-full"
};
const _hoisted_6 = {
    key: 0,
    id: "sku-tag-search-input-tags-list",
    class: "flex flex-wrap gap-2 max-h-[4.5rem] overflow-y-auto"
};
const _hoisted_7 = ["id", "onClick"];
const _hoisted_8 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-close" }, null, -1);
const _hoisted_9 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "icon marso-icon-remove" }, null, -1);
const _hoisted_10 = [
    _hoisted_9
];
const _hoisted_11 = ["id", "onClick", "onMouseenter"];
const vue_3 = require("vue");
const debounce_1 = __importDefault(require("lodash/debounce"));
const SearchInputOption_1 = __importDefault(require("../Form/SearchInput/SearchInputOption"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'SkuTagSearchInput',
    props: {
        placeholder: { default: '' },
        modelValue: { default: '' },
        options: { default: () => [] },
        initialTags: { default: () => [] },
        searchType: { default: '' },
        id: { default: () => { var _a; return `sku-tag-search-input-${(_a = (0, vue_3.getCurrentInstance)()) === null || _a === void 0 ? void 0 : _a.uid}`; } },
        lgMaxWidth: { default: '200px' }
    },
    emits: ["update:modelValue", "select", "tagsChanged"],
    setup(__props, { expose, emit }) {
        const props = __props;
        const searchValue = (0, vue_3.ref)(props.modelValue);
        const debouncedSearchValue = (0, vue_3.ref)(props.modelValue);
        const selectedTags = (0, vue_3.ref)([]);
        const options = (0, vue_3.ref)(props.options);
        const highlightedIndex = (0, vue_3.ref)(-1);
        const validatedTagValues = (0, vue_3.ref)(new Set());
        const filteredOptions = (0, vue_3.computed)(() => {
            if (!debouncedSearchValue.value)
                return [];
            const search = debouncedSearchValue.value.toLowerCase();
            return options.value.filter((option) => (option.label.toLowerCase().includes(search) ||
                option.value.toLowerCase().includes(search)) &&
                !selectedTags.value.some(tag => tag.value === option.value)).slice(0, 10);
        });
        const updateDebouncedSearch = (0, debounce_1.default)((value) => {
            debouncedSearchValue.value = value;
        }, 300);
        const clearSearch = () => {
            searchValue.value = '';
            debouncedSearchValue.value = '';
            highlightedIndex.value = -1;
            updateDebouncedSearch.cancel();
            emit('update:modelValue', '');
        };
        const handleKeydown = (event) => {
            switch (event.key) {
                case 'Enter':
                    if (highlightedIndex.value >= 0 && filteredOptions.value.length > 0) {
                        selectOption(filteredOptions.value[highlightedIndex.value]);
                    }
                    else if (searchValue.value) {
                        const values = searchValue.value.split(/[,;]/).map(v => v.trim()).filter(Boolean);
                        values.forEach(value => {
                            if (!selectedTags.value.some(tag => tag.value === value)) {
                                selectedTags.value.push({ value, label: value });
                            }
                        });
                        clearSearch();
                        emit('tagsChanged', selectedTags.value);
                    }
                    break;
                case 'ArrowDown':
                    event.preventDefault();
                    if (filteredOptions.value.length > 0) {
                        highlightedIndex.value = Math.min(highlightedIndex.value + 1, filteredOptions.value.length - 1);
                    }
                    break;
                case 'ArrowUp':
                    event.preventDefault();
                    if (filteredOptions.value.length > 0) {
                        highlightedIndex.value = Math.max(highlightedIndex.value - 1, 0);
                    }
                    break;
                case 'Escape':
                    highlightedIndex.value = -1;
                    break;
            }
        };
        const handleInputChange = () => {
            highlightedIndex.value = -1;
            emit('update:modelValue', searchValue.value);
            updateDebouncedSearch(searchValue.value);
        };
        const handleBlur = () => {
            setTimeout(() => {
                clearSearch();
            }, 200);
        };
        const selectOption = (option) => {
            if (!selectedTags.value.some(tag => tag.value === option.value)) {
                selectedTags.value.push(option);
                validatedTagValues.value.add(option.value);
                clearSearch();
                emit('select', option);
                emit('tagsChanged', selectedTags.value);
            }
        };
        const isTagValid = (tag) => {
            return options.value.some(option => option.value === tag.value) || validatedTagValues.value.has(tag.value);
        };
        const removeTag = (tag) => {
            selectedTags.value = selectedTags.value.filter(t => t.value !== tag.value);
            emit('tagsChanged', selectedTags.value);
        };
        const resetTags = () => {
            selectedTags.value = [];
            clearSearch();
            validatedTagValues.value.clear();
            emit('tagsChanged', selectedTags.value);
        };
        expose({
            hasInvalidTag: (0, vue_3.computed)(() => selectedTags.value.some(tag => !isTagValid(tag)))
        });
        (0, vue_3.watch)(() => props.searchType, () => {
            options.value = props.options;
            const hadTags = selectedTags.value.length > 0;
            selectedTags.value = [];
            clearSearch();
            validatedTagValues.value.clear();
            if (hadTags) {
                emit('tagsChanged', selectedTags.value);
            }
        });
        // Mindig frissítse az opciókat, ha a prop változik.
        (0, vue_3.watch)(() => props.options, (newOptions) => {
            options.value = newOptions;
            if (selectedTags.value.length > 0 && (newOptions === null || newOptions === void 0 ? void 0 : newOptions.length)) {
                const available = new Set(newOptions.map(option => option.value));
                selectedTags.value.forEach(tag => {
                    if (available.has(tag.value)) {
                        validatedTagValues.value.add(tag.value);
                    }
                });
            }
        });
        (0, vue_3.onMounted)(() => {
            var _a, _b;
            if ((_a = props.initialTags) === null || _a === void 0 ? void 0 : _a.length) {
                selectedTags.value = props.initialTags.map(tagValue => new SearchInputOption_1.default(tagValue, tagValue));
                if ((_b = options.value) === null || _b === void 0 ? void 0 : _b.length) {
                    const available = new Set(options.value.map(option => option.value));
                    props.initialTags.forEach(tagValue => {
                        if (available.has(tagValue)) {
                            validatedTagValues.value.add(tagValue);
                        }
                    });
                }
            }
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                id: __props.id,
                class: "relative w-full"
            }, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", {
                        id: "sku-tag-search-input-search-container",
                        class: "flex flex-row items-center gap-1 h-full border border-gray focus-within:outline-none focus-within:ring-4 focus-within:ring-blue focus-within:ring-opacity-50 rounded-md transition-all duration-300 w-full lg:max-w-[var(--lg-mw)]",
                        style: (0, vue_2.normalizeStyle)({ '--lg-mw': __props.lgMaxWidth })
                    }, [
                        _hoisted_3,
                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                            id: "sku-tag-search-input-input",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((searchValue).value = $event)),
                            placeholder: __props.placeholder,
                            class: "outline-none rounded-md py-2 px-2 w-full placeholder-gray-dark text-[15px] h-12",
                            onInput: handleInputChange,
                            onKeydown: handleKeydown,
                            onBlur: handleBlur
                        }, null, 40, _hoisted_4), [
                            [vue_2.vModelText, searchValue.value]
                        ])
                    ], 4),
                    (0, vue_2.createElementVNode)("div", _hoisted_5, [
                        (selectedTags.value.length > 0)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_6, [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(selectedTags.value, (tag) => {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                        id: `sku-tag-search-input-tag-${tag.value}`,
                                        key: tag.value,
                                        class: "rounded p-1 flex flex-row items-center gap-1 cursor-pointer bg-gray",
                                        onClick: ($event) => (removeTag(tag))
                                    }, [
                                        (0, vue_2.createElementVNode)("span", {
                                            class: (0, vue_2.normalizeClass)({ 'text-orange-dark': !isTagValid(tag) })
                                        }, (0, vue_2.toDisplayString)(tag.label), 3),
                                        _hoisted_8
                                    ], 8, _hoisted_7));
                                }), 128))
                            ]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (selectedTags.value.length > 1)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                key: 1,
                                id: "sku-tag-search-input-reset-btn",
                                class: "btn btn-rounded btn-neutral !bg-red !text-white ml-auto",
                                type: "reset",
                                title: "Reset tags",
                                onClick: resetTags
                            }, _hoisted_10))
                            : (0, vue_2.createCommentVNode)("", true)
                    ])
                ]),
                ((0, vue_2.unref)(filteredOptions).length > 0 && searchValue.value.length > 0)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("ul", {
                        key: 0,
                        id: "sku-tag-search-input-dropdown",
                        class: "absolute top-full left-0 right-0 max-h-60 overflow-y-auto bg-white border border-gray z-10 shadow-sm lg:max-w-[var(--lg-mw)]",
                        style: (0, vue_2.normalizeStyle)({ '--lg-mw': __props.lgMaxWidth })
                    }, [
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(filteredOptions), (option, index) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", {
                                id: `sku-tag-search-input-option-${option.value}`,
                                key: option.value,
                                class: (0, vue_2.normalizeClass)([
                                    'cursor-pointer p-2 border-t border-gray',
                                    { 'bg-gray': highlightedIndex.value === index }
                                ]),
                                onClick: ($event) => (selectOption(option)),
                                onMouseenter: ($event) => (highlightedIndex.value = index)
                            }, (0, vue_2.toDisplayString)(option.label), 43, _hoisted_11));
                        }), 128))
                    ], 4))
                    : (0, vue_2.createCommentVNode)("", true)
            ], 8, _hoisted_1));
        };
    }
});
